/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PermissionAction = {
    Read: 'Read',
    Write: 'Write'
} as const;
export type PermissionAction = typeof PermissionAction[keyof typeof PermissionAction];


export function PermissionActionFromJSON(json: any): PermissionAction {
    return PermissionActionFromJSONTyped(json, false);
}

export function PermissionActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionAction {
    return json as PermissionAction;
}

export function PermissionActionToJSON(value?: PermissionAction | null): any {
    return value as any;
}

